import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Input from "../../ui/Input";
import { unsavedChanges } from "../../../App";
import { fetchFieldChoices, postFieldChoice } from "../../../services/httpClient";
import FieldChoiceCard from "./FieldChoiceCard";

interface ChoiceState {
  noteTypeId?: any;
  fieldId?: any;
  fieldChoices?: any;
  getNotes?: any;
  archived?: boolean | number | null | undefined;
  published?: boolean | number | null | undefined;
  setErrMessage?: any;
  setOrgToSave?: any;
  setShowToast?: any;
  setToastText?: any;
  setToastBody?: any;
}

const FieldChoices = ({
  noteTypeId,
  fieldId,
  fieldChoices,
  getNotes,
  archived,
  published,
  setErrMessage,
  setOrgToSave,
  setShowToast,
  setToastText,
  setToastBody,
}: ChoiceState) => {
  const [choices, setChoices] = useState<any[]>([]);
  const [newOption, setNewOption] = useState<string>("");
  const [showAdd, setShowAdd] = useState<boolean>(false);
  const [enableSave, setEnableSave] = useState<boolean>(false);

  useEffect(() => {
    if (fieldChoices) {
      setChoices(fieldChoices);
    } else {
      getChoices();
    }
  }, []);

  const getChoices = () => {
    fetchFieldChoices(noteTypeId, fieldId)
      .then((res: any) => {
        const data = res[0].data;
        const fc = data.filter((d: any) => d.name !== null);
        setChoices(fc);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  const updateOption = (e: any) => {
    setNewOption(e.target.value);
    setEnableSave(true);
  };

  const onClickSaveSubmit = (e: any) => {
    e?.preventDefault();
    onClickSave();
  };

  const onClickSave = () => {
    const option = {
      name: newOption,
    };

    setErrMessage("");

    postFieldChoice(option, noteTypeId, fieldId)
      .then((res: any) => {
        unsavedChanges.value = false;
        setOrgToSave(false);
        getChoices();
        getNotes();
        setShowToast(true);
        setToastText("Note Type Field Choice Created");
        setToastBody(newOption);
        setNewOption("");
      })
      .catch((err: any) => {
        setErrMessage(err?.response?.data?.msg);
      });
  };

  const onClickCancel = () => {
    setNewOption("");
    setShowAdd(false);
  };

  const onClickAdd = (e: any) => {
    e.stopPropagation();

    setShowAdd(true);
  };

  return (
    <>
      {choices.length > 0 &&
        choices?.map((item: any, index: number) => (
          <Row key={index}>
            <Col xs={6}>
              <FieldChoiceCard
                noteTypeId={noteTypeId}
                fieldId={fieldId}
                item={item}
                getItems={getChoices}
                getNotes={getNotes}
                archived={archived}
                published={published}
                setOrgToSave={setOrgToSave}
                setErrMessage={setErrMessage}
                setShowToast={setShowToast}
                setToastText={setToastText}
                setToastBody={setToastBody}
              />
            </Col>
          </Row>
        ))}
      {showAdd ? (
        <Form onSubmit={(e: any) => onClickSaveSubmit(e)}>
          <Row className="mb-2">
            <Col xs={6}>
              <Input label="New Choice" type="text" value={newOption} onUpdate={(e: any) => updateOption(e)} hasFocus={true} />
            </Col>
            <Col xs={"auto"} className="d-flex align-items-center">
              <Button type="submit" className="app-secondary-color button me-3" disabled={enableSave ? false : true}>
                Add
              </Button>
              <div className="vr my-2" />
              <Button className="app-primary-color button ms-3" onClick={() => onClickCancel()}>
                Cancel
              </Button>
            </Col>
          </Row>
        </Form>
      ) : (
        !published && (
          <div className="mb-2">
            <a href="#blank" className={"quick-link cursor-pointer ms-1"} onClick={(e: any) => onClickAdd(e)}>
              Add Choice
            </a>
          </div>
        )
      )}
    </>
  );
};

export default FieldChoices;
